import { render, staticRenderFns } from "./RawData.vue?vue&type=template&id=5edda3ec&scoped=true&"
import script from "./RawData.vue?vue&type=script&lang=js&"
export * from "./RawData.vue?vue&type=script&lang=js&"
import style0 from "./RawData.vue?vue&type=style&index=0&id=5edda3ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edda3ec",
  null
  
)

export default component.exports